// extracted by mini-css-extract-plugin
export default {"title":"auth_title__dzryZ","loading":"auth_loading__a12Ru","wrapper":"auth_wrapper__ueM4V","hint":"auth_hint__qXsjz","noSession":"auth_noSession__ntEsU"};